import { render, staticRenderFns } from "./basicknowledge.vue?vue&type=template&id=361f6456&scoped=true&"
import script from "./basicknowledge.vue?vue&type=script&lang=js&"
export * from "./basicknowledge.vue?vue&type=script&lang=js&"
import style0 from "./basicknowledge.vue?vue&type=style&index=0&id=361f6456&scoped=scoped&lang=scss&"
import style1 from "./basicknowledge.vue?vue&type=style&index=1&id=361f6456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f6456",
  null
  
)

export default component.exports